import React from 'react';

import { useIntl } from 'react-intl';

import { Box } from '@atlaskit/primitives/compiled';
import {
	isStoreAssistant,
	type StoreAssistant,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';
import { SystemMessage } from '@atlassian/conversation-assistant-ui-components/ui/SystemMessage';

import messages from './SharedChatContinuationPill.messages';

const isSharedSnapshotAssistantMessage = (message: StoreChatItem): message is StoreAssistant =>
	isStoreAssistant(message) &&
	Boolean(message.content.message.message.message_metadata?.sharedFromMessageId);

const getSharedChatContinuationPillTarget = (
	conversationMessages: ReadonlyArray<StoreChatItem>,
): StoreChatItem | undefined => {
	for (let i = conversationMessages.length - 1; i >= 0; i--) {
		const message = conversationMessages[i];
		if (message && isSharedSnapshotAssistantMessage(message)) {
			return message;
		}
	}

	return undefined;
};

const SharedChatContinuationPillComponent = (): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box testId="shared-chat-continuation-pill">
			<SystemMessage
				message={formatMessage(messages.sharedChatContinuationPill)}
				showIcon={false}
			/>
		</Box>
	);
};

type SharedChatContinuationPillType = (() => JSX.Element) & {
	getTarget: (conversationMessages: ReadonlyArray<StoreChatItem>) => StoreChatItem | undefined;
};

export const SharedChatContinuationPill: SharedChatContinuationPillType = Object.assign(
	SharedChatContinuationPillComponent,
	{
		getTarget: getSharedChatContinuationPillTarget,
	},
);
